module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-22-4ec94f65155c185b8756afa2bd093770.jpg";